import { IconButton, Button, Grid, makeStyles } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { useState } from "react"
import ScheduleIcon from '@material-ui/icons/Schedule'
import { actulizarVigenciaCotizacionAction, obtenerCotizacionesAction } from "../../../ducks/cotizacioensDuck"
import { ToastMessage } from "../../../global/ToastMessage"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import PickerMod from "../../../global/PickersMod"
import { FormatoFecha, esFechaValida } from "../../../utils/FormatFecha"
import { DIAS_PERMITIR_VIGENCIA_FECHA } from "../../../constant/constantes"

export const FVigenciaStyle = makeStyles((theme) => ({
    textField: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    textFieldMultiLinea: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    formControl: {
        width: "97%",
        margin: "5px",
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotones: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "2%"
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "1160px",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        maxWidth: "1160px",
        minWidth: "500px",
    },
}))

const FVigencia = (props) => {
    const {idCotizacion} = props
    const [open, setOpen] = useState(false)
    const [vigencia, setVigencia] = useState(new Date())
    const dispatch = useDispatch()
    const classes = FVigenciaStyle()

    const handleClose = () => {
        setOpen(false)
        setVigencia(new Date())
    }
    const onSend = () => {
        if (!esFechaValida({date: vigencia})) {
            return null
        }
        dispatch(onLoadAnction({ message: "" }))
        dispatch(actulizarVigenciaCotizacionAction({ fechaExpiracion: FormatoFecha({ date: vigencia, formato: "MMddyyyy"}), idCotizacion})).then(Response => {
            dispatch(offLoadAction())
            if (Response?.status === 500) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }
            if (Response?.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }
            dispatch(obtenerCotizacionesAction())
            handleClose()
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            })
        })
    }
    const handleClick = () => {
        setOpen(true)
    }
    return (
        <div>
            <IconButton aria-label="Vigencia cotización" onClick={handleClick} color="secondary" >
                <ScheduleIcon />
            </IconButton>
            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo="Vigencia cotización"
                />
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} style={{ marginTop: "0.7rem" }}>
                        <PickerMod
                            label="Vigencia cotizacion"
                            setSelectedDate={setVigencia}
                            disableFuture={false}
                            disablePast={false}
                            selectedDate={vigencia}
                            dias={DIAS_PERMITIR_VIGENCIA_FECHA}
                        />
                    </Grid>
                </Grid>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={onSend}
                            className={classes.modalBoton}
                        >
                            Aplicar
                        </Button>
                    </Grid>
                </Grid>
            </ModalBase>
        </div>
    )
}
export default FVigencia